import React from "react";
import { useDrop } from "react-dnd";
import axios from "axios";
import { useSelector } from "react-redux"; // Assuming you're using Redux for state management
import toast from 'react-hot-toast';
import IconCollection from '../../IconCollection/IconCollection';
import SpinnerLoaderBlack from '../../Component/SpinnerLoaderBlack/SpinnerLoaderBlack';
import { gameSubs, submitPlayersAndMatchData, submitPlayersAndMatchDataWithOutPlaySec, teamOneDraggedPlayerList, teamOnePlayerDrop, teamOneTargetPlayerList } from '../../redux/reducers/playersReducer';
// If using toast for notifications

const DroppableTeamOnePlayer = ({
  player,
  onPlayerDrop,
  playerId,
  teamOneColor,
  actionPlayerId,
  assistSelections,
  shortSelections,
  shortFieldSelections,
  event_team_a_id,
  event_id,
  event_group_id,
  quarter,
  minutes,
  seconds,
  token,
  matchData,
  playerPersonalFoulCount,
  handlePlayerSelectionOne,
  dispatch,
  isLoadingOne,
  setIsLoadingOne,
  setTargetedPlayerTeamOne,
  setDraggedPlayerTeamOne,
  targetedPlayerTeamOne,
  draggedPlayerTeamOne
}) => {

  const teamOneDraggedPlayerListData = useSelector(state => state?.playersReducer?.teamOneDraggedPlayerList);


  const handlePlayerTeamOneDrop = async (draggedPlayer, targetPlayer) => {
    // Fix #5: Prevent self-substitution
    if (draggedPlayer.roster_id === targetPlayer.roster_id) return;

    setIsLoadingOne(true);

    // Optimistic Redux update
    dispatch(teamOnePlayerDrop({
      targetPlayer: targetPlayer.roster_id,
      draggedPlayer: draggedPlayer.roster_id,
    }));
    setTargetedPlayerTeamOne(targetPlayer.jersey_number);
    setDraggedPlayerTeamOne(draggedPlayer.jersey_number);

    // Fix #2: Add 20s timeout (matches bulk subs pattern)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 20000);

    try {
      // Step 1: Record substitution
      const data = new FormData();
      data.append("score_timer", minutes * 60 + seconds);
      data.append("event_id", event_id);
      data.append("eg_id", event_group_id);
      data.append("t_id", event_team_a_id);
      data.append("score_period", quarter);
      data.append("r_id_1_org", targetPlayer.roster_id);
      data.append("r_id_1_new", draggedPlayer.roster_id);

      const response = await fetch(
        `${process.env.REACT_APP_API_ROOT}/api/add_subs/`,
        { method: "POST", body: data, headers: { Authorization: `${token}` }, signal: controller.signal }
      );
      const result = await response.json();
      clearTimeout(timeoutId);

      if (result.error) {
        throw new Error(result.error);
      }

      dispatch(gameSubs(result.game_data.game_subs));

      // Step 2: Sync player status
      const draggedPlayerData = matchData?.team_a_rosters.find(p => p.roster_id === draggedPlayer.roster_id);
      const targetPlayerData = matchData?.team_a_rosters.find(p => p.roster_id === targetPlayer.roster_id);

      const statusData = [
        { r_id: draggedPlayer.roster_id, t_id: event_team_a_id, event_id, eg_id: event_group_id, present: true, startinglinup: true, play_sec: draggedPlayerData?.play_sec || 0 },
        { r_id: targetPlayer.roster_id, t_id: event_team_a_id, event_id, eg_id: event_group_id, present: true, startinglinup: false, play_sec: targetPlayerData?.play_sec || 0 },
      ];

      const formdata = new FormData();
      formdata.append("data", JSON.stringify(statusData));

      const statusResp = await axios.post(
        `${process.env.REACT_APP_API_ROOT}/api/playerStatus/`, formdata,
        { headers: { Authorization: `${token}` } }
      );

      if (statusResp.data.data !== null) {
        dispatch(submitPlayersAndMatchDataWithOutPlaySec(statusResp.data.data));
      }
      toast.success("Substitution successful");
    } catch (err) {
      clearTimeout(timeoutId);
      // Revert optimistic update
      dispatch(teamOnePlayerDrop({
        targetPlayer: draggedPlayer.roster_id,
        draggedPlayer: targetPlayer.roster_id,
      }));
      // Fix #4: Show meaningful error toast
      const msg = err.name === 'AbortError' ? 'Substitution timed out' : (err.message || 'Substitution failed');
      toast.error(msg);
      console.error("Substitution error:", err);
    } finally {
      // Fix #3: Loading ALWAYS clears regardless of success/failure
      setIsLoadingOne(false);
      setDraggedPlayerTeamOne(null);
      setTargetedPlayerTeamOne(null);
    }
  };

  const [{ isOver }, drop] = useDrop({
    accept: "teamOnePlayer",
    drop: (item) => { handlePlayerTeamOneDrop(item.player, player); },
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
  });

  return (
    <button
      ref={(isLoadingOne && draggedPlayerTeamOne === player.jersey_number) ? null : drop}
      onClick={() => handlePlayerSelectionOne(playerId)}
      className={`relative lg:max-w-[108.26px] max-w-[44px]  w-full lg:h-[148px] h-[60.15px] cursor-pointer `}
      disabled={
        (isLoadingOne && draggedPlayerTeamOne === player.jersey_number) ||
        (isLoadingOne && targetedPlayerTeamOne === player.jersey_number) ||
        (actionPlayerId === player.roster_id && assistSelections) ||
        (actionPlayerId !== player.roster_id && shortSelections) ||
        (actionPlayerId === player.roster_id && shortSelections || shortFieldSelections)
      }
    >

      {
        player?.captain && (
          <div className="absolute top-[7px] md:top-[22px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
            c
          </div>
        )
      }
      {isLoadingOne && draggedPlayerTeamOne === player.jersey_number ? (
        <div className="absolute flex justify-center z-10 items-center left-0 top-0 bottom-0 right-0">
          <SpinnerLoaderBlack />
        </div>
      ) : isLoadingOne && targetedPlayerTeamOne === player.jersey_number && <div className="absolute flex justify-center z-10 items-center left-0 top-0 bottom-0 right-0">
        <SpinnerLoaderBlack />
      </div>}

      {actionPlayerId === player.roster_id && assistSelections && (
        <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
      )}
      {actionPlayerId !== player.roster_id &&
        (shortSelections || shortFieldSelections) && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
      {actionPlayerId === player.roster_id &&
        (shortSelections || shortFieldSelections) && (
          <div className="w-full bg-transparent cursor-not-allowed h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
      <IconCollection
        name="player-jersey-white"
        svgFillColor={teamOneColor}
        customClass="lg:w-[108.26px] w-[44px] w-full lg:h-[148px] h-[60.15px]"
      />
      <p
        className={`font-bebas lg:text-[64px] text-[24px] text-white absolute lg:top-[30px] top-[12px] right-0 left-0 text-center `}
      >
        {player.jersey_number}
      </p>
      <div className="absolute lg:top-[115px] top-[46px] right-0 left-0 justify-center flex lg:gap-[2px] gap-[.81px] items-center">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className={`border-[.67px] rounded-full lg:w-2 lg:h-2 w-[3.25px] h-[3.25px]`}
            style={{
              background:
                index <
                  playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                  ? "white"
                  : "transparent",
              borderColor:
                index <
                  playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                  ? "white"
                  : "white",
            }}
          ></div>
        ))}
      </div>
    </button>
  );
};

export default DroppableTeamOnePlayer;
